import React, {FC, useEffect, useState} from "react";
import {Card, Form, Select} from "antd";
import {AdminDesignManagement} from "../admin-design-management.type";
import Service1FormPros = AdminDesignManagement.Service1FormPros;

const GovServiceForm: FC<Service1FormPros> = (props: any) => {
    const [govList, setGovList] = useState([]);

    useEffect(() => {
        props.form.setFieldsValue(props.configData['ru']);
    }, [props.selectedItem]);

    useEffect(() => {
        if (props.govServices) {
            setGovList(props.govServices.hits.map(x => ({
                value: x.id,
                label: x.displayName
            })));
        }
    }, [props.govServices]);

    return (
        <Form form={props.form} layout="vertical">
            <Card title="Государственные услуги">
                <Form.Item
                    label="Ссылка 1"
                    name="govServiceLink1"
                >
                    <Select options={govList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 2"
                    name="govServiceLink2"
                >
                    <Select options={govList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 3"
                    name="govServiceLink3"
                >
                    <Select options={govList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 4"
                    name="govServiceLink4"
                >
                    <Select options={govList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 5"
                    name="govServiceLink5"
                >
                    <Select options={govList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 6"
                    name="govServiceLink6"
                >
                    <Select options={govList}/>
                </Form.Item>
            </Card>
        </Form>
    );
};

export default GovServiceForm;
